/** 站点 SEO 基础配置（与 portal-nuxt/utils/siteSeo.ts 保持同步） */
export const SITE_URL = 'https://bixinpaper.com'
export const SITE_NAME = '笔芯科研'
export const SITE_AUTHOR = '笔芯科研'
export const SITE_OG_IMAGE = `${SITE_URL}/og-image.png`

export const DEFAULT_KEYWORDS =
  '笔芯科研, 论文降重, 降AIGC率, 知网降重, 维普降重, 万方降重, AI降重, 毕业论文查重'

export const DEFAULT_DESCRIPTION =
  '笔芯科研专为毕业论文与期刊稿件提供AI降重、降AIGC与双降处理，对标知网、维普、万方等检测体系，段落级语义重构，保留学术原意，登录即可在线试用。'

export const DEFAULT_TITLE = 'AI降重_降AIGC疑似率_毕业论文双降润色系统 - 笔芯科研官网'

export const DEFAULT_H1 = '毕业论文AI降重 · 降AIGC· 双降润色（知网/维普/万方）'

/** 各页面 SEO（路由 path → 配置） */
export const PAGE_SEO = {
  '/': {
    title: DEFAULT_TITLE,
    h1: DEFAULT_H1,
    description:
      '笔芯科研是一款专为毕业论文打造的AI降重与降AIGC工具，支持对标知网、维普、万方等主流检测系统。提供智能降查重、降AI疑似度、一键双降与学术深度润色，保留专业术语与行文逻辑，助您轻松合规过审。',
    keywords: 'AI降重, 降低AIGC率, 论文降重, 知网降AI, 毕业论文查重修改, 笔芯科研',
    robots: 'index, follow'
  },
  '/reduce-aigc': {
    title: '降低AIGC率_知网维普AI检测疑似度怎么降 - 笔芯科研',
    h1: '降低AIGC率 · 知网维普AI疑似度优化',
    description:
      '针对各大高校知网、维普等系统严查AI代写痛点，笔芯科研自研逆向去AI痕迹算法，打破大模型句式特征与高频词套路，实测有效将AIGC疑似率降至安全标准，保持原文论点连贯与学术严谨。立即登录工作台试用。',
    keywords: '降低AIGC率, 知网降AIGC, 维普AI检测率, 论文去AI痕迹, 降低AI疑似度',
    robots: 'index, follow'
  },
  '/reduce-plagiarism': {
    title: '论文AI降重软件_知网维普万方快速降重 - 笔芯科研',
    h1: '论文降重 · 知网维普万方连续重复优化',
    description:
      '专为毕业论文、期刊学术论文开发的智能降重工具。采用深度同义替换、句式重构与语序逻辑重组技术，精准化解知网、万方等连续重复标红段落，告别生硬通假词，实现自然流畅的降重效果。',
    keywords: '论文降重, 论文查重修改, 知网降重软件, 维普论文降重, AI论文改写',
    robots: 'index, follow'
  },
  '/dual-reduction': {
    title: '论文双降_查重率与AIGC率一键双降处理 - 笔芯科研',
    h1: '论文双降 · 查重率与AIGC率同步达标',
    description:
      '查重率和AIGC率同时超标怎么办？笔芯科研提供双降引擎，同步规避传统抄袭库比对与AI生成算法判定，一次改写达成双指标达标，省时省力，毕业季终审必备工具。',
    keywords: '论文双降, 降查重降AIGC, 毕业论文双降, 论文双指标修改',
    robots: 'index, follow'
  },
  '/academic-polish': {
    title: '学术论文润色_毕业论文语法规范与句式优化 - 笔芯科研',
    h1: '学术论文润色 · 语法规范与句式优化',
    description:
      '针对答辩论文与期刊投稿提供学术级润色服务。规范学术表达语法、剔除口语化表达、优化段落论据衔接，提升论文专业度与可读性，可与降重、降AIGC分步配合使用。',
    keywords: '学术论文润色, 毕业论文润色, 论文降口语化, 学术语言规范',
    robots: 'index, follow'
  },
  '/pricing': {
    title: '套餐价格_字数计费说明与安全保障 - 笔芯科研',
    h1: '套餐价格与字数计费说明',
    description:
      '透明计费，按字计费无隐藏收费。笔芯科研支持单篇试用与多套餐选择，科研点数长期有效；传输加密与任务隔离处理，全方位保障论文数据与隐私安全。登录工作台即可充值。',
    keywords: '笔芯科研价格, 论文降重费用, 降AIGC收费标准, 降重套餐, 字数永久有效',
    robots: 'index, follow'
  },
  '/faq': {
    title: '常见问题解答_知网规则/AIGC判定与退款保障 - 笔芯科研',
    h1: '常见问题 · 知网规则与AIGC判定',
    description:
      '汇总毕业论文降重与降AI常见疑惑：如何选择合适模型？知网最新AIGC判定规则是什么？处理后格式错乱怎么办？点击查看详细指南与售后保障说明。',
    keywords: '论文降重常见问题, 知网AIGC判定规则, 论文降重答疑, 降AIGC怎么降',
    robots: 'index, follow'
  },
  '/about': {
    title: '关于我们 - 笔芯科研学术文档优化团队',
    h1: '关于笔芯科研 · 团队与技术说明',
    description:
      '笔芯科研官网与团队背景：专注学术文档智能优化，段落级语义重构与多检测体系策略适配，说明产品定位、技术原理与合规自用原则。',
    keywords: '笔芯科研官网, 笔芯科研团队, 学术文档优化, 降重技术原理, 关于笔芯科研',
    robots: 'index, follow'
  },
  '/terms': {
    title: '用户服务协议 - 笔芯科研',
    h1: '笔芯科研 用户服务协议',
    description: '笔芯科研用户服务协议：学术文档处理服务的权利义务与使用规范。',
    robots: 'index, follow'
  },
  '/privacy': {
    title: '隐私政策 - 笔芯科研',
    h1: '笔芯科研 隐私政策',
    description: '笔芯科研隐私政策：说明科研文档处理过程中个人信息的收集、使用与保护方式。',
    robots: 'index, follow'
  },
  '/workbench': {
    title: '在线降重降AIGC工作台_粘贴文本与Word全文 - 笔芯科研',
    h1: '在线降重降AIGC工作台',
    description:
      '笔芯科研在线工作台：粘贴段落或上传 Word 全文，选择知网/维普/万方等策略，一键降重、降 AIGC、双降或学术润色，任务进度可追踪。',
    keywords: '在线降重, 降AIGC工作台, 论文降重工具, 双降处理, docx全文降重',
    robots: 'index, follow'
  },
  '/detect': {
    title: 'AIGC检测与查重辅助 - 笔芯科研',
    h1: 'AIGC 检测与查重辅助',
    description: '笔芯科研AIGC与查重相关辅助工具，配合降重、降AIGC与双降工作流使用。',
    keywords: 'AIGC检测, 论文查重辅助, 知网维普万方',
    robots: 'index, follow'
  },
  '/literature': {
    title: '文献检索与综述辅助 - 笔芯科研',
    h1: '文献检索与综述辅助',
    description: '笔芯科研文献综述辅助，快速梳理研究主题相关文献。',
    robots: 'noindex, follow'
  },
  '/ppt': {
    title: '答辩PPT生成 - 笔芯科研',
    h1: '答辩 PPT 生成',
    description: '笔芯科研答辩 PPT 生成，上传论文或答辩材料，一键生成可下载的演示文稿。',
    robots: 'index, follow'
  },
  '/word-slim': {
    title: 'Word文档瘦身压缩 - 笔芯科研',
    h1: 'Word 文档瘦身',
    description: '笔芯科研 Word 文档瘦身，压缩体积便于提交与传输。',
    robots: 'noindex, follow'
  },
  '/image-aigc': {
    title: '图片AIGC处理 - 笔芯科研',
    h1: '图片AIGC处理',
    description: '笔芯科研图片相关AIGC辅助工具。',
    robots: 'noindex, follow'
  }
}

export const LANDING_PAGE_SECTIONS = {
  '/reduce-aigc': [
    {
      heading: '为什么知网、维普AIGC疑似度难降',
      body: '高校检测不仅看重复率，还会识别大模型常见的句式模板、连接词密度与段落节奏。简单同义词替换往往无法降低AI特征，需要针对检测逻辑做语义级改写。'
    },
    {
      heading: '笔芯科研如何降低AIGC率',
      body: '按所选检测体系配置改写策略，在保持论点与术语准确的前提下打散AI痕迹，适合答辩稿、期刊修回与盲审前自检。'
    }
  ],
  '/reduce-plagiarism': [
    {
      heading: '连续重复标红怎么改',
      body: '知网、万方等系统对连续字符重复敏感。笔芯科研通过句式重构与逻辑重组，降低连续重复片段，同时避免生硬堆砌导致可读性下降。'
    },
    {
      heading: '适用哪些文稿',
      body: '学位论文各章节、期刊论文正文与综述部分均可处理，支持段落试改与 docx 全文流程。'
    }
  ],
  '/dual-reduction': [
    {
      heading: '什么时候需要双降',
      body: '当查重率与AIGC率同时接近或超过学校阈值时，分两次手工改稿成本高。双降在一次任务中链式处理两类指标。'
    },
    {
      heading: '双降与单功能如何选择',
      body: '仅重复率高可选降重；仅AI标红可选降 AIGC；终审前建议双降并预留复检时间。'
    }
  ],
  '/academic-polish': [
    {
      heading: '润色解决什么问题',
      body: '口语化表达、语法不规范、段落衔接生硬等问题会影响答辩与投稿印象。润色侧重学术语体与逻辑层次，不替代查重合规责任。'
    },
    {
      heading: '与降重如何配合',
      body: '可先润色提升可读性，再按需降重或降 AIGC；英文摘要等场景可单独选择对应服务类型。'
    }
  ]
}

/** 无需收录的页面 */
const NOINDEX_RULES = [
  { type: 'exact', path: '/login' },
  { type: 'prefix', path: '/login/' },
  { type: 'prefix', path: '/workbench/task' },
  { type: 'prefix', path: '/workbench/invite' }
]

function isNoIndexPath(path) {
  return NOINDEX_RULES.some(rule => {
    if (rule.type === 'exact') return path === rule.path
    return path.startsWith(rule.path)
  })
}

export function resolvePageSeo(path) {
  if (isNoIndexPath(path)) {
    return {
      title: `${SITE_NAME} - 工作台`,
      h1: `${SITE_NAME} 工作台`,
      description: DEFAULT_DESCRIPTION,
      robots: 'noindex, nofollow'
    }
  }
  const page = PAGE_SEO[path]
  if (page) {
    return {
      h1: page.h1 || DEFAULT_H1,
      keywords: page.keywords || DEFAULT_KEYWORDS,
      ...page
    }
  }
  return {
    title: DEFAULT_TITLE,
    h1: DEFAULT_H1,
    description: DEFAULT_DESCRIPTION,
    keywords: DEFAULT_KEYWORDS,
    robots: 'index, follow'
  }
}
